/**
 * Light quiz-bank catalog (slot_content_protection · quiz client cutover 29 JUN).
 *
 * Just the IDs of banks that actually exist — NO questions/answers. The client
 * imports this (instead of the heavy `quiz-banks.ts`) to answer "does this sprint
 * have a final test?" without pulling every question into the bundle. The real
 * bank (with questions) is fetched per-id from the gated `/api/quiz/banks/:id`.
 *
 * MUST stay in sync with `QUIZ_BANKS` in `quiz-banks.ts` — a drift guard in
 * `src/data/__tests__/quiz-banks.test.ts` asserts these match exactly.
 *
 * Note: sprints S16-S17 banks are now authored (added to QUIZ_BANKS) and listed
 * here. S18-S19 carry a `finalTestBankId` in metadata but their banks are not
 * authored yet, so they stay ABSENT — `quizBankExists` returns false for them,
 * keeping the final-test CTA hidden until a bank lands.
 */
export const QUIZ_BANK_IDS = [
  'sprint-01',
  'sprint-02',
  'sprint-03',
  'sprint-04',
  'sprint-05',
  'sprint-07',
  'sprint-08',
  'sprint-09',
  'sprint-10',
  'sprint-11',
  'sprint-12',
  'sprint-13',
  'sprint-14',
  'sprint-15',
  'sprint-16',
  'sprint-17',
  'block1-exam',
  'block2-exam',
  'block3-exam',
  'ctfl-mock-1',
  'ctfl-mock-2',
] as const;

const QUIZ_BANK_ID_SET: ReadonlySet<string> = new Set(QUIZ_BANK_IDS);

/** Does a bank with this id actually exist (light · no question import)? */
export const quizBankExists = (bankId: string | undefined): boolean =>
  !!bankId && QUIZ_BANK_ID_SET.has(bankId);

/**
 * Pass threshold per bank as a PERCENT (0-100) — `Math.round(bank.passThreshold
 * * 100)`. Light companion (no questions) so `entitlement.ts` (shared with the
 * gated edge `content` fn) can judge sprint completeness against the stored
 * `finalTestScore` (also a pct · ADR-019 · P5) WITHOUT importing the heavy
 * quiz-banks aggregator, which would bloat the content function's cold-compile
 * graph (slot_content_protection · 29 JUN). MUST stay in sync with QUIZ_BANKS —
 * a drift guard in `src/data/__tests__/quiz-banks.test.ts` asserts it exactly.
 */
export const QUIZ_BANK_PASS_PCT: Record<string, number> = {
  'sprint-01': 70,
  'sprint-02': 75,
  'sprint-03': 75,
  'sprint-04': 75,
  'sprint-05': 75,
  'sprint-07': 80,
  'sprint-08': 80,
  'sprint-09': 80,
  'sprint-10': 80,
  'sprint-11': 80,
  'sprint-12': 80,
  'sprint-13': 83,
  'sprint-14': 83,
  'sprint-15': 83,
  'sprint-16': 83,
  'sprint-17': 83,
  'block1-exam': 70,
  'block2-exam': 70,
  'block3-exam': 70,
  'ctfl-mock-1': 65,
  'ctfl-mock-2': 65,
};
